// extracted by mini-css-extract-plugin
module.exports = {"tooltip-text":"Handle_tooltip-text__21nR9"};